import { render, staticRenderFns } from "./RtaTriggersList.vue?vue&type=template&id=1d364418&scoped=true&"
import script from "./RtaTriggersList.vue?vue&type=script&lang=js&"
export * from "./RtaTriggersList.vue?vue&type=script&lang=js&"
import style0 from "./RtaTriggersList.vue?vue&type=style&index=0&id=1d364418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d364418",
  null
  
)

export default component.exports